<template lang="html">
  <div class="mult-select">
    <div class="dp-trigger" @click="showDropdown" v-if="rntValue.key">
      {{ rntValue.value }}
    </div>
    <div class="dp-trigger placeholder" @click="showDropdown" v-else>
      {{ placeholder }}
    </div>
    <slide-panel ref="slidePanel" v-if="show" :background="background" :screenHeight="screenHeight">
      <template slot="header">
        <div class="slide-header">
          <span v-if="multiple" style="float: left" @click="hideDropdown">取消</span>
          <span>{{ title }}</span>
          <span v-if="multiple" style="float: right" class="confirm-btn" @click="confirm">确认</span>
        </div>
      </template>
      <template slot="main">
        <cube-scroll>
          <div class="dp-item-list">
            <div
              class="dp-item"
              v-for="(el, index) in options"
              :key="index"
              @click="select(el)"
            >
              <div class="text" v-text="el.text"></div>
              <div class="check" v-if="el.check">
                <span class="iconfont icon-right"></span>
              </div>
            </div>
          </div>
        </cube-scroll>
      </template>
    </slide-panel>
  </div>
</template>
<script type="ecmascript-6">
import SlidePanel from '@/components/slidePanel'
import '@/assets/font-icon/iconfont.css'
export default {
  name: "mult-select",
  data() {
    return {
      screenHeight: 0,
      show: false,
      options: [],
      rntValue: {
        value: '',
        key: ''
      },
      tmp:[],
      speArr: []
    }
  },
  props: {
    background: {
      type: String,
      default: 'transparent'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    title: {
      type: String,
      default: ''
    },
    speValue: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 100
    },
    multiple: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    // data() {
    //   this._initOptions()
    // },
    data: {
      immediate: true,
      handler(value) {
        this._initOptions()
      }
    },
    value() {
      this._initOptions()
    }
  },
  components: {
    SlidePanel
  },
  mounted() {
    // this.screenHeight = window.innerHeight
    // window.onresize = () => {
    //   return (() => {
    //     this.screenHeight = window.innerHeight;
    //   })()
    // }
    // if (this.speValue+'' != '') {
    //   this.speValue.split(',') || []
    // }
    //   this._initOptions()
    // })
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    showDropdown() {
      this.show = true
      this.$nextTick(() => {
        this.$refs.slidePanel.showSlide()
        // 渲染选项
        // this.rntValue.key = key
        this.tmp = []
        // alert(2222)
        this._initOptions()
      })
    },
    hideDropdown() {
      this.show = false
      this.zIndex = -1
    },
    select(el) {
      this.$emit('deleteSelect',el)
      let indexNum = null
      // console.log(el)
      this.tmp = []
      let arr = this.speArr
      // console.log(el.check)
      // console.log(this.speValue != '',el.value == this.speValue,this.speValue,el.value,el.check,this.multiple)
      // if (this.speValue+'' != '' && el.value == this.speValue && !el.check && this.multiple) {
      if (arr.includes(el.value+'') && !el.check && this.multiple) {
        this.options.map((e, index) => {
          if (el.value == e.value) {
            e.check = true
            this.tmp.push(e)
          }else{
            e.check = false
          }
        })
      }else {
        this.options.map((e, index) => {
          if (e === el) {
            el.check = !el.check
            // this.multiple ? el.check = !el.check : el.check = true
          } else if (!this.multiple) {
            e.check = false
          }
          // if(this.speValue+'' != '' && e.value == this.speValue ){
          if(arr.includes(e.value+'')){
            e.check = false
          }
          if (e.check) {
            this.tmp.push(e)
          }
        })
      }
      // if (el.value = this.speValue && el.check && this.multiple) {
      //   this.tmp = [];
      //   this.tmp.push(el)
      // }
      // console.log(this.tmp)
      // 判断最多 个数
      if (this.tmp.length > this.max && this.multiple) {
        indexNum = this.tmp.indexOf(el)
        el.check = false
        this.tmp.splice(indexNum, 1)
        this.$createToast({
          type: 'txt',
          time: 1000,
          txt: '最多只能选择' + this.max + '个'
        }).show()
      }
      // 单选 关闭    多选  不关闭
      if(!this.multiple){
        this.confirm()
      }
      // this.confirm()
    },
    confirm () {
      this.rntValue = {
        value: '',
        key: ''
      }
      let arr = []
      this.tmp.map((e) => {
        this.rntValue.value += e.text + ' '
        this.rntValue.key += e.value + ' '
        arr.push(Number(e.value))
      })
      this.$emit('input', this.rntValue.key ? (this.multiple ? arr : arr[0]) : this.multiple ? [] : '')
      this.$emit('change', this.rntValue.key.trim(), this.multiple ? this.rntValue.key.trim().split(' ') : this.rntValue.key)
      this.hideDropdown()
    },
    _initOptions() {
      if (this.multiple) {
        this.speArr = this.speValue+'' != '' ? (this.speValue+'').split(',') : []
      }
      Object.assign(this.options, this.data)
      this.rntValue.value = ''
      // console.log(typeof(this.value),this.value, (this.value + "" || ''))
      this.rntValue.key = typeof(this.value) != 'object' ? (this.value + "" || '') : this.value ? this.value.join(' ') : ''
      // console.log(this.rntValue.key)
      let selectedList =  this.rntValue.key.split(' ')
      // console.log(selectedList.length)
      if (selectedList.length > 0)
      this.options.map((el) => {
        this.$set(el, 'check', false)
        this.$set(el, 'minWeightRange', '')
        this.$set(el, 'maxWeightRange', '')
        // console.log(el.value)
        if (selectedList.indexOf(el.value + "") > -1) {
          el.check = true
          this.rntValue.value += el.text + ' '
          this.tmp.push(el)
        }
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
// @import '~./font/iconfont.css'
@import '~./mixin'
.mult-select
  .dp-trigger
    padding-right: 8px
    font-size: 14px
    height: 20px
    line-height: 20px
    text-align: right
    max-width: 45vw
    // min-width: 30px
    float: right
    overflow: hidden
    text-overflow:ellipsis
    white-space: nowrap
    &.placeholder
      color: #ccc
      font-size: 14px

// .slide-enter-active, .slide-leave-active
//   transition: all 0.3s
// .slide-enter, .slide-leave-to
//   transform: translate3d(0, 100%, 0)
.slide-container
  left: 0
.dp-item-list
  .dp-item
    padding: 8px 0
    margin: 0 15px
    border-bottom: 1px solid #ECECEC
    flex(row, ceter, space-between)
    font-size: 12px
    .text
      font-weight: bold
      height: 22px
      line-height: 22px
      color: #333
    .check
      font-size: 12px
      color: #F10215
.cube-scroll-wrapper
  max-height: 40vh
.slide-header
  padding: 0 20px
  text-align: center
  position: relative
  border-bottom: 1px solid #ECECEC
  span
    font-size: 16px
  .confirm-btn
    color: $color-button
</style>
